import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/index.css';
import { showError, showSuccess } from '../utils/alertas';

// --- 🛠️ CONFIGURAÇÃO DE CONEXÃO ---
const IS_PROD = true; 
const API_BASE_URL = IS_PROD 
    ? 'https://sigoapi.jhe-etes.com.br/api' 
    : 'http://localhost:3001/api';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  // ✅ MELHORIA: Ao carregar o login, limpa qualquer lixo de sessão antiga
  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !senha) return showError("Campos Vazios", "Preencha e-mail e senha.");

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, senha }) 
      });

      const data = await response.json();

      if (response.ok) {
        // ✅ SUCESSO: Armazena o token de 1h gerado pelo backend
        localStorage.setItem('token', data.token); 
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // Alerta bonito e padronizado
        await showSuccess("Acesso Permitido", `Bem-vindo de volta, ${data.user.nome}!`);
        
        // Navega para o Mapa
        navigate('/'); 
      } else {
        // ❌ ERRO DE CREDENCIAIS (Mensagem vinda do server.js)
        showError("Falha no Login", data.message || "E-mail ou senha incorretos.");
      }
    } catch (error) {
      console.error("Erro no fetch:", error);
      showError(
        "Erro de Conexão", 
        "Não foi possível conectar ao servidor SIGO. Tente novamente em instantes."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 font-sans p-4">
      {/* Container Principal Animado */}
      <div className="bg-white p-6 sm:p-10 rounded-[2.5rem] shadow-2xl w-full max-w-md border border-gray-100 relative overflow-hidden animate-fadeIn">
        
        {/* Faixa decorativa Sabesp */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-900 via-sabesp-blue to-sabesp-cyan"></div>

        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center mx-auto mb-4 shadow-inner">
            <span className="text-4xl">💧</span>
          </div>
          <h1 className="text-3xl font-black text-slate-800 tracking-tight">SIGO <span className="text-sabesp-blue">Sabesp</span></h1>
          <p className="text-slate-400 font-bold uppercase tracking-widest text-[10px] mt-2">Sistema Integrado de Gestão de Obras</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[11px] font-black text-slate-400 uppercase ml-1 tracking-wider">E-mail / Usuário</label>
            <input 
              type="text" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-2xl text-slate-700 font-bold focus:bg-white focus:border-sabesp-cyan outline-none transition-all placeholder:text-slate-300 shadow-sm"
              placeholder="exemplo@sabesp.com.br"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-[11px] font-black text-slate-400 uppercase ml-1 tracking-wider">Senha de Acesso</label>
            <input 
              type="password" 
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-2xl text-slate-700 font-bold focus:bg-white focus:border-sabesp-cyan outline-none transition-all placeholder:text-slate-300 shadow-sm"
              placeholder="••••••••"
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-4 bg-slate-900 text-white font-black text-xs uppercase tracking-[0.2em] rounded-2xl shadow-xl hover:bg-sabesp-blue hover:-translate-y-1 transition-all flex justify-center items-center active:scale-95 disabled:opacity-50 disabled:translate-y-0 mt-8"
          >
            {loading ? (
                <div className="flex items-center gap-3">
                    <span className="w-4 h-4 border-2 border-white/20 border-t-white rounded-full animate-spin"></span>
                    <span>Validando...</span>
                </div>
            ) : 'Acessar Painel'}
          </button>
        </form>

        <div className="mt-10 text-center border-t border-slate-50 pt-8">
            <button 
                onClick={() => navigate('/')}
                className="text-slate-400 text-[10px] font-black hover:text-sabesp-cyan transition-colors flex items-center justify-center gap-2 mx-auto group uppercase tracking-widest"
            >
                <span className="group-hover:-translate-x-1 transition-transform text-lg">←</span> Voltar ao Mapa Público
            </button>
        </div>
      </div>
    </div>
  );
}

export default Login;